(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-watch-buy-reels"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const reelRow = document.querySelector('.reels-row');
    const modal = document.querySelector('.reels-modal');
    const nextBtn = document.querySelector('.next-btn');
    const prevBtn = document.querySelector('.prev-btn');
    const closeBtn = document.querySelector('.close');
    const modalNext = document.querySelector('.modal-next');
    const modalPrev = document.querySelector('.modal-prev');

    if (!reelRow) return;

    /* =========================
     INFINITE CLONE
  ========================= */
    const originals = Array.from(reelRow.querySelectorAll('.reel'));
    const realCount = originals.length;

    originals.forEach((r) => reelRow.appendChild(r.cloneNode(true)));
    originals
      .slice()
      .reverse()
      .forEach((r) => reelRow.prepend(r.cloneNode(true)));

    let allReels = Array.from(reelRow.querySelectorAll('.reel'));
    let reelIndex = realCount;
    let isAnimating = false;
    let activeVideo = null;

    /* =========================
     LAZY LOAD VIDEO
  ========================= */
    function lazyLoad(video) {
      if (!video || video.dataset.loaded) return;
      const src = video.querySelector('source');
      if (src) {
        video.src = src.src;
        video.load();
        video.dataset.loaded = 'true';
      }
    }

    /* =========================
     SCROLL TO REEL
  ========================= */
    function scrollToReel(index, instant = false) {
      if (isAnimating && !instant) return;
      isAnimating = true;
      reelIndex = index;

      const target = allReels[reelIndex];
      if (!target) return;

      const left = target.offsetLeft - reelRow.clientWidth / 2 + target.clientWidth / 2;

      reelRow.scrollTo({
        left,
        behavior: instant ? 'auto' : 'smooth',
      });

      setTimeout(
        () => {
          isAnimating = false;
          if (reelIndex >= realCount * 2) {
            reelIndex = realCount;
            scrollToReel(reelIndex, true);
          } else if (reelIndex < realCount) {
            reelIndex += realCount;
            scrollToReel(reelIndex, true);
          }
        },
        instant ? 50 : 500
      );
    }

    window.addEventListener('load', () => scrollToReel(reelIndex, true));

    /* =========================
     PLAY / PAUSE
  ========================= */
    function playReel(reel) {
      const video = reel.querySelector('video');
      const bar = reel.querySelector('.reel-progress span');
      if (!video) return;

      lazyLoad(video);

      if (activeVideo && activeVideo !== video) {
        activeVideo.pause();
      }

      activeVideo = video;
      video.play().catch(() => {});

      video.ontimeupdate = () => {
        if (video.duration && bar) {
          bar.style.width = (video.currentTime / video.duration) * 100 + '%';
        }
      };

      video.onended = () => {
        if (!modal.classList.contains('active')) {
          scrollToReel(reelIndex + 1);
        }
      };
    }

    function pauseReel(reel) {
      const video = reel.querySelector('video');
      const bar = reel.querySelector('.reel-progress span');
      video?.pause();
      if (bar) bar.style.width = '0%';
    }

    if (window.matchMedia('(hover: hover)').matches) {
      allReels.forEach((reel) => {
        reel.addEventListener('mouseenter', () => playReel(reel));
        reel.addEventListener('mouseleave', () => pauseReel(reel));
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (isAnimating) return;
        entries.forEach((entry) => {
          entry.isIntersecting ? playReel(entry.target) : pauseReel(entry.target);
        });
      },
      { threshold: 0.75 }
    );

    allReels.forEach((r) => observer.observe(r));

    nextBtn?.addEventListener('click', () => scrollToReel(reelIndex + 1));
    prevBtn?.addEventListener('click', () => scrollToReel(reelIndex - 1));

    /* =========================
     MODAL CAROUSEL
  ========================= */
    const slides = Array.from(document.querySelectorAll('.modal-slide'));
    let modalIndex = 0;

    function updateModal() {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        const bar = slide.querySelector('.modal-progress span');

        slide.classList.remove('is-active', 'is-left', 'is-right', 'is-hidden');

        // Reset
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.ontimeupdate = null;
        }
        if (bar) bar.style.width = '0%';

        const diff = (i - modalIndex + slides.length) % slides.length;

        if (diff === 0) {
          slide.classList.add('is-active');

          if (!video) return;

          lazyLoad(video);

          video.play().catch(() => {});

          // ✅ PROGRESS BAR UPDATE (FIX)
          video.ontimeupdate = () => {
            if (!video.duration || !bar) return;
            bar.style.width = (video.currentTime / video.duration) * 100 + '%';
          };

          // Optional: auto-next when video ends
          video.onended = () => {
            modalIndex = (modalIndex + 1) % slides.length;
            updateModal();
          };
        } else if (diff === 1) {
          slide.classList.add('is-right');
        } else if (diff === slides.length - 1) {
          slide.classList.add('is-left');
        } else {
          slide.classList.add('is-hidden');
        }
      });
    }

    allReels.forEach((reel, i) => {
      reel.addEventListener('click', (e) => {
        // ❌ BLOCK SOUND / WISHLIST / DRAWER
        if (
          e.target.closest('.sound') ||
          e.target.closest('.wish') ||
          e.target.closest('.drawer-toggle') ||
          e.target.closest('.reel-footer')
        )
          return;

        modalIndex = i % realCount;
        modal.classList.add('active');
        updateModal();
      });
    });

    closeBtn?.addEventListener('click', () => {
      modal.classList.remove('active');
      slides.forEach((s) => {
        const v = s.querySelector('video');
        if (v) {
          v.pause();
          v.currentTime = 0;
        }
      });
    });

    modalNext?.addEventListener('click', () => {
      modalIndex = (modalIndex + 1) % slides.length;
      updateModal();
    });

    modalPrev?.addEventListener('click', () => {
      modalIndex = (modalIndex - 1 + slides.length) % slides.length;
      updateModal();
    });

    /* =========================
     SOUND TOGGLE (REELS + MODAL)
  ========================= */
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.sound, .sound-toggle');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const wrapper = btn.closest('.reel, .modal-slide');
      const video = wrapper?.querySelector('video');
      if (!video) return;

      video.muted = !video.muted;
      btn.textContent = video.muted ? '🔇' : '🔊';

      video.play().catch(() => {});
    });

    /* =========================
     DRAWER TOGGLE
  ========================= */
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('.drawer-toggle');
      if (!toggle) return;

      e.preventDefault();
      e.stopPropagation();

      const drawer = toggle.closest('.reel-drawer');
      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', !expanded);
      toggle.textContent = expanded ? '▲' : '▼';
      drawer.classList.toggle('open');
    });

    /* =========================
   ADD TO CART – REFRESH & OPEN CART
========================= */
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-atc]');
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();

      const button = form.querySelector('button[type="submit"]');
      if (!button) return;

      const originalText = button.textContent;

      // 🔄 START LOADER
      button.classList.add('atc-loading');
      button.disabled = true;
      button.textContent = 'Adding';

      const drawer = form.closest('.reel-drawer') || form.closest('.modal-drawer-info');

      const resetButton = () => {
        button.classList.remove('atc-loading');
        button.disabled = false;
        button.textContent = originalText;
      };

      if (!drawer) {
        resetButton();
        return;
      }

      const variantsEl = drawer.querySelector('.product-variants');
      if (!variantsEl) {
        resetButton();
        return;
      }

      const variants = JSON.parse(variantsEl.textContent);
      const selects = drawer.querySelectorAll('select[data-option]');
      let variant = null;

      if (!selects.length) {
        variant = variants.find((v) => v.available) || variants[0];
      } else {
        variants.forEach((v) => {
          const ok = [...selects].every((sel) => v.options.includes(sel.value));
          if (ok) variant = v;
        });
      }

      if (!variant) {
        alert('Variant unavailable');
        resetButton();
        return;
      }

      try {
        // 1️⃣ ADD TO CART
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: variant.id,
            quantity: 1,
          }),
        });

        // 2️⃣ SET FLAG & REFRESH
        sessionStorage.setItem('openCartDrawer', 'true');
        window.location.reload();
      } catch (err) {
        console.error(err);
        resetButton();
        alert('Unable to add product');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
